import { useNavigate } from 'react-router-dom'
export const MovieListItem = (props) => {
    const { image, href, title, views } = props
    const navigate = useNavigate()

    const handleClickItem = () => {
      navigate('/')
    }
    return (
        <div className='flex justify-between p-1 cursor-pointer dark:text-white' onClick={handleClickItem}>
            <div className='w-5/12'>
                <img src={image} className="block"/>
            </div>
            <div className='w-7/12 p-1'>
                <div className='text-sm'>{title}</div>
                <div className='text-xs'>{views} lượt xem</div>
            </div>
        </div>
    )
}
